import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';

import { AgreementsRoutes } from './subsections/Agreements/Agreements';
import { EntitiesRoutes } from './subsections/Entities/Entities';
import { GroupsRoutes } from './subsections/Groups/Groups';

export const Entities = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.network">Network</Trans>}
      tabs={[
        {
          id: 'entities',
          label: <Trans id="settings.organization.entities.entities">Entities</Trans>,
        },
        { id: 'groups', label: <Trans id="settings.organization.entities.groups">Groups</Trans> },
        {
          id: 'agreements',
          label: <Trans id="settings.organization.entities.agreements">Agreements</Trans>,
        },
      ]}
    >
      <Routes>
        <Route path="" element={<Navigate to="/settings_beta/network/entities" replace />} />
        <Route path="entities/*" element={<EntitiesRoutes />} />
        <Route path="groups/*" element={<GroupsRoutes />} />
        <Route path="agreements/*" element={<AgreementsRoutes />} />
        <Route path="*" element={<Navigate to="/settings_beta/network" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
